/**
 *
 * @description index.tsx
 * @author yikkok <yikok.yong@gmail.com>
 * @version 1.0.0
 * @since 14 November 2021
 *
 */

import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import { BlogT } from '~/@customTypes/blog.type';

import Container from '~/components/other/Container';
import SimpleBlog from '~/v2/components/blog/SimpleBlog';
import Layout from '~/v2/components/layout/Layout';
import SectionTitle from '~/v2/components/typography/SectionTitle';
import { fetchBlogs } from '~/v2/services/blogs.service';

type Props = {
  posts: Array<BlogT>;
};
export default function Blogs({ posts }: Props) {
  return (
    <Layout
      title='Blogs'
      head={
        <>
          <link rel='canonical' href='https://beccato.com.my/blogs' />
        </>
      }
    >
      <Container>
        <Breadcrumb separator='>'>
          <Breadcrumb.Item>
            <i className='fas fa-home' />
            <FormattedMessage id='app.common.home' defaultMessage='Home' />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <FormattedMessage id='app.common.blogs' defaultMessage='Blogs' />
          </Breadcrumb.Item>
        </Breadcrumb>

        <div className='blogs'>
          <SectionTitle title={<FormattedMessage id='app.common.blogs' defaultMessage='Blogs' />} className='-left' />
        </div>

        <SimpleBlog posts={posts} />
      </Container>
    </Layout>
  );
}

export const getStaticProps = async () => {
  const posts = await fetchBlogs('cn');

  return {
    props: {
      posts: (posts && posts) || [],
      revalidate: 3600,
    },
  };
};
